import { useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';
import type { HeartDataResponse } from '../lib/types';

export function useHeartContent() {
  const [data, setData] = useState<HeartDataResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [seed, setSeed] = useState<number>(() => Math.floor(Math.random() * 1000000));

  const loadData = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await api.getHeartData();
      setData(result);
    } catch (err: unknown) {
      const errorMsg = err instanceof Error ? err.message : 'Failed to load keepsake content';
      setError(errorMsg);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const rearrange = useCallback(() => {
    setSeed(Math.floor(Math.random() * 1000000));
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return {
    data,
    isLoading,
    error,
    seed,
    reload: loadData,
    rearrange,
  };
}
